// extracted by mini-css-extract-plugin
export default {"tableHead":"PriceTable_tableHead__L6yPf"};